/**
 * Ink 진입점 헬퍼 (단일 소스: config/ink.php + App\Ink\Support\InkSeo)
 *
 * 랜딩(SPA)에서 Ink 로 나가는 링크와 대문(/ink)이 그리는 작품 목록 · 문구는 **서버가 정한 값**을 쓴다.
 * landing.blade.php 가 `window.JadEye.ink` 로 주입한다(INK_ENABLED=false 면 null).
 *
 * 🚨 컴포넌트에 작품을 손으로 적지 않는다 — 작품이 늘면 서버가 채우고 화면이 저절로 따라온다
 *    (Pin 은 축을 손으로 나열하던 자리마다 한 칸씩 샜다 — lib/pin.ts 주석).
 */

export interface InkEntry {
    /** 대문 — '/ink'. 사람이 보는 진입점(앱바 · 카드 · 푸터)은 전부 여기로 간다. */
    landing: string;

    /** 서가 — '/ink/works'(서버 렌더). */
    shelf: string;

    /** 한 줄 소개 — 「이야기가 번지는 곳」. 푸터 · 카드가 같은 말을 쓴다. */
    tagline: string;

    /** 대문 머리의 문장들. */
    subtitle: string[];

    /** 「Ink의 약속」. */
    promises: InkPoint[];

    /** 작품 전체 — 서버의 `InkSeo::works()` 를 옮긴 것이다. */
    works: InkWork[];
}

export interface InkWork {
    slug: string;
    /** 작품 홈 — '/ink/works/{slug}'(서버 렌더). */
    path: string;
    /** translation(여기서 읽는다) / intro(소개만 — 밖의 연재처로 보낸다) */
    kind: 'translation' | 'intro';
    /** 메뉴 이름 — 서버 렌더 화면의 둘째 줄 메뉴와 **같은 라벨**이다. */
    label: string;
    tagline: string;
    summary: string;
    points: InkPoint[];
    cta: string;
}

export interface InkPoint {
    icon: string;
    title: string;
    desc: string;
}

/**
 * Ink 진입점 반환. **꺼져 있거나 주입되지 않았으면 null** 이다(getPin 과 같은 규칙 — 예외를 던지지 않는다).
 */
export function getInk(): InkEntry | null {
    if (typeof window === 'undefined') {
        return null;
    }

    const ink = (window as unknown as { JadEye?: { ink?: InkEntry | null } }).JadEye?.ink;

    return ink?.landing && ink?.shelf ? ink : null;
}
